var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8 13.487-2.7 1a.778.778 0 0 1-1-1l1.02-2.71c.04-.11.11-.22.19-.3l.25-.25 5.34-5.37 1.63-1.63c.3-.3.79-.3 1.09 0l1.77 1.78c.17.17.23.38.19.59a.9.9 0 0 1-.25.45l-1.62 1.62-5.59 5.62c-.06.06-.16.15-.32.2Zm6.94-8-1.67-1.68h-.01l-1.32 1.33 1.68 1.68 1.32-1.33Zm-8.62 5.29-.24.25h.01l-1.01 2.68 2.67-1 .24-.24 5.07-5.09-1.68-1.68-5.06 5.08Zm-2.88 5.42h13.12c.24 0 .44.18.44.4 0 .22-.2.4-.44.4H3.44c-.24 0-.44-.18-.44-.4 0-.22.2-.4.44-.4Z",
    fill: "currentColor"
  })));
};
export default SvgEdit;